import { __assign } from "tslib";
import { useEffect, useReducer } from "react";
function menuReducer(state, action) {
    switch (action.type) {
        case "TOGGLE_SIDEBAR":
            return __assign(__assign({}, state), { sideBarOpen: !state.sideBarOpen });
        case "SET_SEARCH_INPUT":
            return __assign(__assign({}, state), { searchInput: action.payload });
        case "SET_ACTIVE_SEARCH":
            return __assign(__assign({}, state), { activeSearch: action.payload });
        case "SET_CATEGORY_OPEN":
            return __assign(__assign({}, state), { categoryOpen: action.payload });
        default:
            return state;
    }
}
export var useMenuState = function (defaultSideBarOpen, onSideBarToggle) {
    var initialState = {
        sideBarOpen: defaultSideBarOpen || false,
        searchInput: "",
        activeSearch: "",
        categoryOpen: null,
    };
    var _a = useReducer(menuReducer, initialState), state = _a[0], dispatch = _a[1];
    var actions = {
        toggleSidebar: function () { return dispatch({ type: "TOGGLE_SIDEBAR" }); },
        setSearchInput: function (value) {
            return dispatch({ type: "SET_SEARCH_INPUT", payload: value });
        },
        setActiveSearch: function (value) {
            return dispatch({ type: "SET_ACTIVE_SEARCH", payload: value });
        },
        setCategoryOpen: function (value) {
            return dispatch({ type: "SET_CATEGORY_OPEN", payload: value });
        },
    };
    useEffect(function () {
        if (state.searchInput || state.searchInput === "") {
            dispatch({ type: "SET_ACTIVE_SEARCH", payload: state.searchInput });
        }
    }, [state.searchInput]);
    useEffect(function () {
        onSideBarToggle === null || onSideBarToggle === void 0 ? void 0 : onSideBarToggle(state.sideBarOpen);
    }, [state.sideBarOpen]);
    return { state: state, actions: actions };
};
//# sourceMappingURL=useMenuState.js.map